export enum CompanySiteType {
  BiesseVenue = "biesse-venue",
  ProductionSite = "production-site",
  Dealer = "dealer",
}
